import React from 'react';

const CustomerServiceIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || 29.944}
    height={props.size || 33.5}
    xmlSpace="preserve"
    viewBox="0 0 29.944 33.5"
    {...props}
  >
    <g
      data-name="Grupo 484"
      transform="translate(124.083 -383.583)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1}
    >
      <rect
        data-name="Rect\xE1ngulo 115"
        width={7.111}
        height={10.667}
        rx={2}
        transform="translate(-123.333 400.333)"
      />
      <rect
        data-name="Rect\xE1ngulo 116"
        width={7.111}
        height={10.667}
        rx={2}
        transform="translate(-102 400.333)"
      />
      <path
        data-name="Trazado 577"
        d="M-123.333 403.889v-5.334a14.222 14.222 0 1128.444 0v5.333"
      />
      <path
        data-name="Trazado 578"
        d="M-98.444 411c0 2.946-4.776 5.333-10.667 5.333"
      />
    </g>
  </svg>
);

export default CustomerServiceIcon;
